import type { ApiModuleEndpoints } from '../types'

export const offlinePosApiEndpoints = {
  bootstrap: {
    method: 'GET',
    path: '/offline-pos/bootstrap',
    requiresAuth: true,
  },
  sync: {
    method: 'POST',
    path: '/offline-pos/sync',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
